import React from 'react'
import styled from 'styled-components'

export default {
  circle: (color) => (
    <Circle style={ { backgroundColor: color } } />
  ),
  halfCircleLeft: (color) => (
    <HalfCircleLeft style={ { backgroundColor: color } } />
  ),
  halfCircleRight: (color) => (
    <HalfCircleRight style={ { backgroundColor: color } } />
  ),
  ring: (color) => (
    <Ring style={ { backgroundColor: color } }>
      <InnerRing style={ { backgroundColor: 'white' } } />
    </Ring>
  ),
  halfRingLeft: (color) => (
    <HalfRingLeft style={ { backgroundColor: color } }>
      <InnerHalfRingLeft style={ { backgroundColor: 'white' } } />
    </HalfRingLeft>
  ),
  halfRingRight: (color) => (
    <HalfRingRight style={ { backgroundColor: color } }>
      <InnerHalfRingRight style={ { backgroundColor: 'white' } } />
    </HalfRingRight>
  ),
}

const Circle = styled.div`
  flex: 0 0 auto;
  border-radius: 15px;
  width: 30px;
  height: 30px;
  @media (max-width: 575.98px) {
    width: 20px;
    height: 20px;
  }
  @media (max-width: 767.98px) {
    width: 20px;
    height: 20px;
  }
`
const HalfCircleLeft = styled.div`
  flex: 0 0 auto;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  width: 15px;
  height: 30px;
  @media (max-width: 575.98px) {
    width: 20px;
    height: 20px;
  }
  @media (max-width: 767.98px) {
    width: 10px;
    height: 20px;
  }
`
const HalfCircleRight = styled.div`
  flex: 0 0 auto;
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
  width: 15px;
  height: 30px;
  @media (max-width: 575.98px) {
    width: 20px;
    height: 20px;
  }
  @media (max-width: 767.98px) {
    width: 10px;
    height: 20px;
  }
`
const Ring = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
  border-radius: 15px;
  width: 30px;
  height: 30px;
  @media (max-width: 767.98px) {
    width: 20px;
    height: 20px;
  }
`
const InnerRing = styled.div`
  flex: 0 0 auto;
  border-radius: 12px;
  width: 22px;
  height: 22px;
  @media (max-width: 767.98px) {
    width: 18px;
    height: 18px;
  }
`
const HalfRingLeft = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  width: 15px;
  height: 30px;
  @media (max-width: 767.98px) {
    width: 10px;
    height: 20px;
  }
`
const InnerHalfRingLeft = styled.div`
  flex: 0 0 auto;
  border-top-left-radius: 50px;
  border-bottom-left-radius: 50px;
  width: 9px;
  height: 20px;
  @media (max-width: 767.98px) {
    width: 5px;
    height: 18px;
  }
`
const HalfRingRight = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
  width: 15px;
  height: 30px;
  @media (max-width: 767.98px) {
    width: 10px;
    height: 20px;
  }
`
const InnerHalfRingRight = styled.div`
  flex: 0 0 auto;
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
  width: 9px;
  height: 20px;
  @media (max-width: 767.98px) {
    width: 5px;
    height: 18px;
  }
`



// WEBPACK FOOTER //
// ./src/components/metrolendar/content-templates.js